<div id="pricing" class="pt-2">
	@for(dataItem of data; track $index) {
	<div class="d-flex align-items-center justify-content-center py-2">
		<div class="d-flex flex-wrap px-3" [class]="mobileView ? 'w-100' : 'w-75'">
			@if(dataItem.title){
			<div class="break"></div>
			<span class="heading mb-3">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + dataItem.title | translate }}</span>
			<div class="break"></div>
			}
			<p class="w-100 mb-0">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + dataItem.text | translate }}</p>
			<div class="break"></div>
		</div>
	</div>
	<div class="break"></div>
	}

	<div class="d-flex align-items-center justify-content-center y-2">
		<mat-button-toggle-group
			name="subscription"
			aria-label="Subscription options"
			[value]="selectedSubscriptionPeriod"
			#group="matButtonToggleGroup"
			(change)="checkSubscriptionPeriod(group.value)">
			@for(subscription of subscriptionPeriods; track $index){
			<mat-button-toggle [value]="subscription">
				<span class="p-2">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_PERIOD_' + $index | translate }}</span>
			</mat-button-toggle>
			}
		</mat-button-toggle-group>
	</div>

	<div class="d-flex align-items-stretch justify-content-center pt-2 gap-5">
		@for(group of availableSubscriptionGroups; track $index){
		<div class="d-flex flex-column">
			@for(package of subscriptionPackagesGroups[group]; track $index) {
			<mat-card
				class="w-100 mb-2 px-4 py-3 pricing-list-item"
				[ngClass]="{ 'mt-auto pt-1': package.type === 'discount' }"
				[style.border]="package.type === 'discount' ? '3px solid' : '1px solid'"
				appearance="outlined">
				@if(package.type === 'discount') {
				<div class="d-flex w-100 justify-content-center">
					<span class="savings">
						<mat-icon>keyboard_double_arrow_up</mat-icon>
						{{ getAdditionalPriceCalculationInfo(package, 'SAVINGS', group) }}
						{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_CURRENCY' | translate }}
						({{ utils.formatCurrencyLocale(convertPriceToEuro(getAdditionalPriceCalculationInfo(package, 'SAVINGS', group, true))) }} {{ '€' }})
					</span>
				</div>
				}
				<mat-card-header class="w-100">
					<mat-card-title-group class="w-100">
						<mat-card-title>
							@if(package.type === "discount") {
							<mat-checkbox color="primary" [checked]="checkIsSelected(group)" (change)="selectAllSubscriptionPackage($event, group)">
								<span class="title w-100">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + package.title | translate }}</span>
							</mat-checkbox>
							} @else {
							<mat-checkbox color="primary" [(ngModel)]="package.checked" (change)="checkSubscriptionPackage($event, package, $index)">
								<span class="title w-100">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + package.title | translate }}</span>
							</mat-checkbox>
							}
						</mat-card-title>
						<mat-card-subtitle class="mt-1 mb-2">
							<span class="w-100 title">
								{{ utils.formatCurrencyLocale(getPricingByPackage(package)) }}
								{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_CURRENCY' | translate }}
							</span>
							<span class="w-100 title"> ({{ utils.formatCurrencyLocale(convertPriceToEuro(getPricingByPackage(package))) }} {{ '€' }}) </span>
							<!-- <span>
								{{ getAdditionalPriceCalculationInfo(package, 'PERIOD') }}
							</span> -->
						</mat-card-subtitle>
					</mat-card-title-group>
				</mat-card-header>
				<mat-card-content>
					@if (package.text) {
					<span class="w-100">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + package.text | translate }}</span>
					}</mat-card-content
				>
			</mat-card>
			}
		</div>
		}
	</div>

	<mat-divider class="w-100 my-1"></mat-divider>

	<div class="d-flex justify-content-center p-4 pt-0 w-100">
		<mat-card class="w-25 my-2 px-4 py-1 pricing-list-item" appearance="outlined">
			<div class="d-flex w-100 justify-content-center">
				<span class="savings">
					<mat-icon>keyboard_double_arrow_up</mat-icon>
					{{ getAdditionalPriceCalculationInfo(discountPackage, 'SAVINGS', 'ALL') }}
					{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_CURRENCY' | translate }}
					({{ utils.formatCurrencyLocale(convertPriceToEuro(getAdditionalPriceCalculationInfo(discountPackage, 'SAVINGS', 'ALL', true))) }} {{ '€' }})
				</span>
			</div>
			<mat-card-header class="w-100">
				<mat-card-title-group class="w-100 d-flex justify-content-center">
					<mat-card-title>
						<mat-checkbox color="primary" [checked]="checkIsSelected('ALL')" (change)="selectAllSubscriptionPackage($event, 'ALL')">
							<span class="title w-100">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + discountPackage.title | translate }}</span>
						</mat-checkbox>
					</mat-card-title>
					<mat-card-subtitle class="my-2">
						<span class="title w-100">
							{{ utils.formatCurrencyLocale(getPricingByPackage(discountPackage)) }}
							{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_CURRENCY' | translate }}
						</span>
						<span class="w-100 title"> ({{ utils.formatCurrencyLocale(convertPriceToEuro(getPricingByPackage(discountPackage))) }} {{ '€' }}) </span>
						<span>
							{{ getAdditionalPriceCalculationInfo(discountPackage, 'PERIOD') }}
						</span>
					</mat-card-subtitle>
				</mat-card-title-group>
			</mat-card-header>
			<mat-card-content>
				<div class="d-flex w-100 justify-content-center mt-1"></div>
				@if (discountPackage.text) {
				<span class="w-100">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + discountPackage.text | translate }}</span>
				}</mat-card-content
			>
		</mat-card>
	</div>

	<div class="d-flex align-items-center justify-content-center py-2 total-price mb-4 flex-wrap">
		<span>{{ utils.formatCurrencyLocale(totalPrice) }} {{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_CURRENCY' | translate }}</span>
		<span class="ms-1">({{ utils.formatCurrencyLocale(convertPriceToEuro(totalPrice)) }} {{ '€' }})</span>
		<div class="break w-100"></div>
		<span class="tax-info">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_TAX_INFO' | translate }}</span>
	</div>

	@if(totalPrice !== 0){
	<div class="d-flex align-items-center justify-content-center flex-wrap">
		<div class="my-2 p-2" [class]="mobileView ? 'w-100' : 'w-75'">
			<mat-card class="w-100 my-2 px-4 py-3" appearance="outlined">
				<mat-card-header>
					<mat-card-title-group>
						<mat-card-title>
							<div class="break"></div>
							<span class="heading mb-3">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_SUBSCRIPTION_FORМ' | translate }}</span>
							<div class="break mb-2"></div>
						</mat-card-title>
					</mat-card-title-group>
				</mat-card-header>
				<mat-card-content>
					<div class="d-flex justify-content-center flex-wrap">
						<div class="pe-4" [class]="mobileView ? 'w-100' : 'w-50'">
							<h6>
								{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_SUBSCRIPTION_CATEGORIES' | translate }}
								@if (selectedTags.length === 0 && areTagsRequired()) {
								<span class="attention-text blink">{{
									'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_SUBSCRIPTION_CATEGORIES_ATTENTION' | translate
								}}</span>
								}
							</h6>
							<div class="row">
								<mat-accordion #tagsAccordion="matAccordion" multi togglePosition="before">
									@for (category of categories; track $index) {
									<mat-expansion-panel
										id="tagsAccordionPanel"
										(opened)="accordionAction('open', category)"
										(closed)="accordionAction('close', category)"
										[expanded]="category.isOpened">
										<mat-expansion-panel-header>
											<mat-panel-title>
												<mat-checkbox [checked]="category.checked" [indeterminate]="indeterminate(category)" (change)="selectAll($event, category)"></mat-checkbox>
												<span>{{ utils.getParameterByLanguageScript(category, 'name', true) }}</span>
											</mat-panel-title>
											<mat-panel-description> </mat-panel-description>
										</mat-expansion-panel-header>

										<span class="list-section">
											<ul [id]="'widget-' + utils.getParameterByName(category, 'value')" class="ms-4">
												@for (tag of category.tags; track tag.id) {
												<li class="d-flex align-items-center">
													<mat-checkbox [(ngModel)]="tag.checked" (change)="checkItem($event.checked, tag, category)"> </mat-checkbox>
													<span>
														{{ utils.getParameterByLanguageScript(tag, 'name', true) }}
													</span>
												</li>
												}
											</ul>
										</span>
									</mat-expansion-panel>
									}
								</mat-accordion>
							</div>
						</div>
						<form class="mt-2" [class]="mobileView ? 'w-100' : 'w-50'" [formGroup]="formGroup" #formContactInfoDirective="ngForm" (submit)="subscribe(formContactInfoDirective)">
							<h6>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_SUBSCRIPTION_FORM_INFO' | translate }}</h6>
							<mat-form-field class="w-100 pb-3">
								<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_COMPANY_OR_INDIVIDUAL' | translate }}</mat-label>
								<input type="text" formControlName="clientName" matInput />
							</mat-form-field>

							<mat-form-field class="w-100 pb-3" appearance="outline">
								<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_TAX_ID' | translate }}</mat-label>
								<input type="text" formControlName="taxId" matInput />
							</mat-form-field>

							<mat-form-field class="w-100 pb-3" appearance="outline">
								<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_STATE' | translate }}</mat-label>
								<mat-select color="primary" placeholder="{{ 'ASSORTED.SELECT_OPTION' | translate }}" formControlName="foreignCountry" (selectionChange)="onCountryChange()">
									<mat-option [value]="false">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_STATE_0' | translate }}</mat-option>
									<mat-option [value]="true">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_STATE_1' | translate }}</mat-option>
								</mat-select>
							</mat-form-field>

							@if(formGroup.controls['foreignCountry'].value) {
							<mat-form-field class="w-100 pb-3" appearance="outline">
								<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_STATE_NAME' | translate }}</mat-label>
								<input type="text" formControlName="country" matInput />
							</mat-form-field>
							}

							<mat-form-field class="w-100 pb-3" appearance="outline">
								<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_E_MAIL' | translate }}</mat-label>
								<input type="text" formControlName="email" matInput />
							</mat-form-field>

							<mat-form-field class="w-100 pb-3" appearance="outline">
								<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_ADDRESS' | translate }}</mat-label>
								<input type="text" formControlName="contactAddress" matInput />
							</mat-form-field>

							<mat-form-field class="w-100 pb-3" appearance="outline">
								<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_CITY' | translate }}</mat-label>
								<input type="text" formControlName="contactCity" matInput />
							</mat-form-field>

							<mat-form-field class="w-100 pb-3">
								<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PUBLISH_FORM_CONTACT_NAME' | translate }}</mat-label>
								<input type="text" formControlName="contactPerson" matInput />
							</mat-form-field>

							<mat-form-field class="w-100 pb-3" appearance="outline">
								<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PUBLISH_FORM_CONTACT_PHONE' | translate }}</mat-label>
								<input type="number" formControlName="contactPhone" matInput />
							</mat-form-field>

							<mat-radio-group
								class="w-100 d-flex justify-content-between pb-3"
								formControlName="paymentOption"
								aria-label="Select payment option"
								(change)="onPaymentOptionChange()">
								<mat-radio-button value="INVOICE">{{
									'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_PAY_BY_INVOICE' | translate
								}}</mat-radio-button>

								<mat-radio-button
									value="LINK"
									matTooltip="{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_ONLINE_CREDIT_CARD_PAYMENT' | translate }}"
									matTooltipPosition="below">
									<span>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_PAY_BY_LINK' | translate }}</span>
								</mat-radio-button>
							</mat-radio-group>

							@if (formGroup.controls['paymentOption'].value === 'LINK') {
							<mat-form-field class="w-100 pb-3">
								<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_FIRST_NAME' | translate }}</mat-label>
								<input type="text" formControlName="firstName" matInput />
							</mat-form-field>

							<mat-form-field class="w-100 pb-3">
								<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_LAST_NAME' | translate }}</mat-label>
								<input type="text" formControlName="lastName" matInput />
							</mat-form-field>
							}

							@if (formGroup.controls['paymentOption'].value) {
							<h6>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_BILLING_INFORMATION' | translate }}</h6>

							<mat-checkbox class="w-100 pb-3" color="primary" formControlName="useSameInfo" (change)="onUseSameInfoChange()">
								{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_USE_SAME_INFO' | translate }}
							</mat-checkbox>

							<mat-form-field class="w-100 pb-3">
								<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_COMPANY_OR_INDIVIDUAL' | translate }}</mat-label>
								<input type="text" formControlName="billingClientName" matInput />
							</mat-form-field>

							<mat-form-field class="w-100 pb-3" appearance="outline">
								<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_TAX_ID' | translate }}</mat-label>
								<input type="text" formControlName="billingTaxId" matInput />
							</mat-form-field>

							<mat-form-field class="w-100 pb-3" appearance="outline">
								<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_STATE' | translate }}</mat-label>
								<mat-select color="primary" placeholder="{{ 'ASSORTED.SELECT_OPTION' | translate }}" formControlName="billingForeignCountry">
									<mat-option [value]="false">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_STATE_0' | translate }}</mat-option>
									<mat-option [value]="true">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_STATE_1' | translate }}</mat-option>
								</mat-select>
							</mat-form-field>

							@if(formGroup.controls['billingForeignCountry'].value) {
							<mat-form-field class="w-100 pb-3" appearance="outline">
								<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_STATE_NAME' | translate }}</mat-label>
								<input type="text" formControlName="billingCountry" matInput />
							</mat-form-field>
							}

							<mat-form-field class="w-100 pb-3" appearance="outline">
								<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_E_MAIL' | translate }}</mat-label>
								<input type="text" formControlName="billingEmail" matInput />
							</mat-form-field>

							<mat-form-field class="w-100 pb-3" appearance="outline">
								<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_ADDRESS' | translate }}</mat-label>
								<input type="text" formControlName="billingContactAddress" matInput />
							</mat-form-field>

							<mat-form-field class="w-100 pb-3" appearance="outline">
								<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_CITY' | translate }}</mat-label>
								<input type="text" formControlName="billingContactCity" matInput />
							</mat-form-field>

							@if (formGroup.controls['paymentOption'].value === 'LINK') {
							<mat-form-field class="w-100 pb-3">
								<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PUBLISH_FORM_CONTACT_NAME' | translate }}</mat-label>
								<input type="text" formControlName="billingContactPerson" matInput />
							</mat-form-field>

							<mat-form-field class="w-100 pb-3" appearance="outline">
								<mat-label>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PUBLISH_FORM_CONTACT_PHONE' | translate }}</mat-label>
								<input type="number" formControlName="billingContactPhone" matInput />
							</mat-form-field>
							}
							}

							<span class="w-100 pt-3 font small">
								{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_CONSENT_INFO' | translate }}
							</span>
							<span class="w-100 d-flex justify-content-between">
								<mat-checkbox class="w-100" color="primary" formControlName="termsAndConditions" [checked]="formGroup.controls['termsAndConditions'].value">
									<span [innerHTML]="'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.PRICING_CONSENT' | translate"></span>
								</mat-checkbox>
							</span>
						</form>

						<div class="w-100 mt-5">
							<button
								type="button"
								(click)="subscribe()"
								mat-raised-button
								color="primary"
								class="w-100"
								aria-label="send message button"
								[disabled]="formGroup.invalid || apiLoading.contactForm || (selectedTags.length === 0 && areTagsRequired())">
								@if(apiLoading.contactForm) {
								<mat-spinner diameter="20"></mat-spinner>
								} @else {
								<span>{{ 'BUTTON.SUBSCRIBE' | translate }}</span>
								}
							</button>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
		</div>

		<div class="break"></div>
	</div>
	}
</div>
